module.exports = __webpack_public_path__ + "static/media/tools-slider-img1.f6cb8571.png";